export interface Article {
  handle: string
  title: string
  category: string
  formattedDate: string
  readTime: string
  image: string
  excerpt?: string
  heading1?: string
  paragraph1?: string
  image1_src?: string
  image1_caption?: string
  heading2?: string
  paragraph2?: string
  heading3?: string
  paragraph3?: string
  blockquote?: string
  image2_src?: string
  image2_caption?: string
  product_label?: string
  product_name?: string
  product_description?: string
  product_href?: string
  product_image?: string
  product2_label?: string
  product2_name?: string
  product2_description?: string
  product2_href?: string
  product2_image?: string
  heading4?: string
  paragraph4?: string
  image3_src?: string
  image3_caption?: string
  author_name: string
  author_bio?: string
  author_avatar?: string
  hero_video?: string
}

export interface ArticleListItem {
  handle: string
  title: string
  category: string
  blogHandle: string
  excerpt: string
  publishedAt: string
  author: string
  image: string
  tags: string[]
}

export function useArticle(slug: string) {
  return useAsyncData<Article>(
    `article:${slug}`,
    () => $fetch<Article>(`/api/blog/${slug}`)
  )
}

export function useBlogList() {
  return useAsyncData<ArticleListItem[]>(
    'blog:list',
    () => $fetch<ArticleListItem[]>('/api/blog'),
    { default: () => [] }
  )
}

export function useBlogs() {
  return useAsyncData<{ handle: string; title: string }[]>(
    'blogs',
    () => $fetch<{ handle: string; title: string }[]>('/api/blogs'),
    { default: () => [] }
  )
}
